interface PageData {
    [pathname: string]: {
        title: string;
        metaDescription: string;
    };
  }

const baseMetaDescription = "Katon 360 Classroom";
export const pageData:  PageData = {
    "/": {
        title: "Landing Page",
        metaDescription: `${baseMetaDescription} landing page`
    },
    "/admin-login": {
        title: "School Admin Login",
        metaDescription: `${baseMetaDescription} school admin login page`
    },
    "/teacher-login": {
        title: "Teacher Login",
        metaDescription: `${baseMetaDescription} teacher login page`
    },
    "/teacher-select-class": {
        title: "Teacher Select Class",
        metaDescription: `${baseMetaDescription} teacher select class page`
    },
    "/teacher-settings/profile": {
        title: "Teacher Profile",
        metaDescription: `${baseMetaDescription} teacher profile page`
    },
    "/pta-signup": {
        title: "PTA Signup",
        metaDescription: `${baseMetaDescription} PTA signup page`
    },
    "/pta-login": {
        title: "PTA Login",
        metaDescription: `${baseMetaDescription} pta login page`
    },
    "/pta-verifyCode": {
        title: "PTA Verify Code",
        metaDescription: `${baseMetaDescription} pta verify code page`
    },
    "/pta-meetings": {
        title: "PTA Meetings",
        metaDescription: `${baseMetaDescription} pta meetings`
    },
    "/student-signup": {
        title: "Student Signup",
        metaDescription: `${baseMetaDescription} student signup page`
    },
    "/student-login": {
        title: "Student Login",
        metaDescription: `${baseMetaDescription} student login page`
    },
    "/faq": {
        title: "Faq",
        metaDescription: `${baseMetaDescription} faq page`
    },
    "/legal": {
        title: "legal",
        metaDescription: `${baseMetaDescription} legal page`
    },
    "/support": {
        title: "support",
        metaDescription: `${baseMetaDescription} support page`
    },
    "/admin-dashboard": {
        title: "School Admin Dashboard",
        metaDescription: `${baseMetaDescription} school admin dashboard page`
    },
    "/admin-workshop": {
        title: "School Admin Workshop",
        metaDescription: `${baseMetaDescription} school admin workshop page`
    },
    "/admin-notification": {
        title: "School Admin Notification",
        metaDescription: `${baseMetaDescription} school admin notification page`
    },
    "/admin-system-message": {
        title: "School Admin System Message",
        metaDescription: `${baseMetaDescription} school admin system message page`
    },
    "/admin-settings": {
        title: "School Admin Settings",
        metaDescription: `${baseMetaDescription} school admin settings page`
    },
    "/admin-help": {
        title: "School Admin Help",
        metaDescription: `${baseMetaDescription} school admin help page`
    },
    "/admin-help/admin-terms-and-privacy-policy": {
        title: "School Admin Terms And Privacy Policy",
        metaDescription: `${baseMetaDescription} school admin terms and privacy policy page`
    },
    "/admin-school": {
        title: "School Admin Profile",
        metaDescription: `${baseMetaDescription} school admin profile page`
    },
    "/admin-calendar": {
        title: "School Admin Calendar",
        metaDescription: `${baseMetaDescription} school admin calendar page`
    },
    "/admin-pta": {
        title: "School Admin PTA",
        metaDescription: `${baseMetaDescription} school admin pta page`
    },
    "/admin-pta/meetings": {
        title: "School Admin PTA",
        metaDescription: `${baseMetaDescription} school admin pta page`
    },
    "/admin/pta/meeting": {
        title: "School Admin PTA Meeting",
        metaDescription: `${baseMetaDescription} school admin pta meeting page`
    },
    "/teacher-classroom": {
        title: "Teacher Classroom",
        metaDescription: `${baseMetaDescription} teacher classroom page`
    },
    "/teacher-classroom/ebooks": {
        title: "Teacher Classroom Ebooks",
        metaDescription: `${baseMetaDescription} teacher classroom ebooks`
    },
    "/teacher-classroom/images": {
        title: "Teacher Classroom Images",
        metaDescription: `${baseMetaDescription} teacher classroom images`
    },
    "/teacher-classroom/podcast": {
        title: "Teacher Classroom Podcast",
        metaDescription: `${baseMetaDescription} teacher classroom podcast page`
    },
    "/teacher-classroom/podcast/materials": {
        title: "Teacher Classroom Podcast Materials",
        metaDescription: `${baseMetaDescription} teacher classroom podcast materials page`
    },
    "/teacher-classroom/videos": {
        title: "Teacher Classroom Videos",
        metaDescription: `${baseMetaDescription} teacher classroom videos page`
    },
    "/teacher-classroom/ebooks/materials": {
        title: "Teacher Classroom Ebooks Materials",
        metaDescription: `${baseMetaDescription} teacher classroom ebooks page`
    },
    "/teacher-classroom/images/materials": {
        title: "Teacher Classroom Images Materials",
        metaDescription: `${baseMetaDescription} teacher classroom images materials page`
    },
    "/teacher-classroom/videos/materials": {
        title: "Teacher Classroom Videos Materials",
        metaDescription: `${baseMetaDescription} teacher classroom videos materials page`
    },
    "/teacher-classroom/chats": {
        title: "Teacher Classroom Chats",
        metaDescription: `${baseMetaDescription} teacher classroom chats page`
    },
    "/teacher-calendar": {
        title: "Teacher Calendar",
        metaDescription: `${baseMetaDescription} teacher calendar page`
    },
    "/teacher-announcement": {
        title: "Teacher Announcement",
        metaDescription: `${baseMetaDescription} teacher announcement page`
    },
    "/teacher-classroom/ebooks/materials/teaching-materials": {
        title: "Teacher Classroom Ebooks Teaching Materials",
        metaDescription: `${baseMetaDescription} teacher classroom ebooks materials page`
    },
    "/teacher-classroom/ebooks/materials/examination-guide": {
        title: "Teacher Classroom Ebooks Examination Guideline",
        metaDescription: `${baseMetaDescription} teacher classroom ebooks materials examination guideline page`
    },
    "/teacher-classroom/ebooks/materials/question-bank": {
        title: "Teacher Classroom Ebooks Question Bank",
        metaDescription: `${baseMetaDescription} teacher classroom ebooks question bank`
    },
    "/teacher-classroom/liveclass": {
        title: "Teacher Classroom Liveclass",
        metaDescription: `${baseMetaDescription} teacher classroom liveclass page`
    },
    "/teacher-classroom/quiz": {
        title: "Teacher Classroom Quiz",
        metaDescription: `${baseMetaDescription} teacher classroom quiz page`
    },
    "/teacher-classroom/assignments": {
        title: "Teacher Classroom Assignments",
        metaDescription: `${baseMetaDescription} teacher classroom assignments page`
    },
    "/teacher-classroom/quiz/test": {
        title: "Teacher Classroom Quiz Test",
        metaDescription: `${baseMetaDescription} teacher classroom quiz test page`
    },
    "/teacher-workshop": {
        title: "Teacher Workshop",
        metaDescription: `${baseMetaDescription} teacher workshop page`
    },
    "/teacher-pta": {
        title: "Teacher PTA",
        metaDescription: `${baseMetaDescription} teacher pta page`
    },
    "/teacher/pta/meeting": {
        title: "Teacher PTA Meeting",
        metaDescription: `${baseMetaDescription} teacher pta meeting page`
    },
    "/teacher-settings'": {
        title: "Teacher Settings",
        metaDescription: `${baseMetaDescription} teacher settings page`
    },
    "/teacher-help": {
        title: "Teacher Help",
        metaDescription: `${baseMetaDescription} teacher help page`
    },
    "/teacher-help/teacher-terms-and-privacy-policy": {
        title: "Teacher Terms And Privacy Policy",
        metaDescription: `${baseMetaDescription} teacher terms and privacy policy page`
    },
    "/student-classroom": {
        title: "Student Classroom",
        metaDescription: `${baseMetaDescription} student classroom page`
    },
    "/student-classroom/ebooks": {
        title: "Student Classroom Ebooks",
        metaDescription: `${baseMetaDescription} student classroom ebooks page`
    },
    "/student-classroom/images": {
        title: "Student Classroom Images",
        metaDescription: `${baseMetaDescription} student classroom images page`
    },
    "/student-classroom/videos": {
        title: "Student Classroom Videos",
        metaDescription: `${baseMetaDescription} student classroom videos page`
    },
    "/student-classroom/ebooks/materials": {
        title: "Student Classroom Ebooks Materials",
        metaDescription: `${baseMetaDescription} student classroom ebooks materials page`
    },
    "/student-classroom/images/materials": {
        title: "Student Classroom Images Materials",
        metaDescription: `${baseMetaDescription} student classroom images materials page`
    },

    "/student-classroom/videos/materials": {
        title: "Student Classroom Videos Materials",
        metaDescription: `${baseMetaDescription} student classroom videos materialspage`
    },
    "/student-classroom/ebooks/materials/learning-materials": {
        title: "Student Classroom Ebooks Learning Materials",
        metaDescription: `${baseMetaDescription} student classroom ebooks learning materials page`
    },

    "/student-classroom/ebooks/materials/examination-guide": {
        title: "Student Classroom Ebooks Examination Guideline",
        metaDescription: `${baseMetaDescription} student classroom ebooks examination guideline page`
    },
    "/student-classroom/ebooks/materials/question-bank": {
        title: "Student Classroom Ebooks Question Bank",
        metaDescription: `${baseMetaDescription} school admin system message page`
    },
    "/student-classroom/quiz": {
        title: "Student Classroom Quiz",
        metaDescription: `${baseMetaDescription} student classroom quiz page`
    },
    "/student-classroom/quiz/test": {
        title: "Student Classroom Quiz Test",
        metaDescription: `${baseMetaDescription} student classroom quiz test page`
    },
    "/student-classroom/quiz/view": {
        title: "Student Classroom Quiz View",
        metaDescription: `${baseMetaDescription} student classroom quiz view page`
    },
    "/student-classroom/liveclass": {
        title: "Student Classroom Liveclass",
        metaDescription: `${baseMetaDescription} student classroom liveclass page`
    },
    "/student-classroom/assignments": {
        title: "Student Classroom Assignments",
        metaDescription: `${baseMetaDescription} student classroom assignments page`
    },
    "/student-classroom/podcast": {
        title: "Student Classroom Podcast",
        metaDescription: `${baseMetaDescription} student classroom podcast page`
    },
    "/student-classroom/podcast/materials": {
        title: "student classroom podcast materials",
        metaDescription: `${baseMetaDescription} student classroom podcast materials page`
    },
    "/student-classroom/chats": {
        title: "student classroom Chats",
        metaDescription: `${baseMetaDescription} student classroom chats page`
    },
    "/student-calendar": {
        title: "Student Calendar",
        metaDescription: `${baseMetaDescription} student calendar page`
    },
    "/student-announcement": {
        title: "Student Announcement",
        metaDescription: `${baseMetaDescription} student announcement page`
    },
    "/teacher-classroom/liveclass/meeting": {
        title: "Teacher Classroom Liveclass Meeting",
        metaDescription: `${baseMetaDescription} teacher classroom liveclass meeting page`
    },
    "/teacher-workshop/meeting": {
        title: "Teacher Workshop Meeting",
        metaDescription: `${baseMetaDescription} teacher workshop meeting page`
    },
    "/admin-workshop/meeting": {
        title: "School Admin Meeting",
        metaDescription: `${baseMetaDescription} school admin meeting page`
    },
    "/student-classroom/liveclass/meeting": {
        title: "Student Classroom Liveclass Meeting",
        metaDescription: `${baseMetaDescription} student classroom liveclass meeting page`
    },
    "/student-settings": {
        title: "Student Settings",
        metaDescription: `${baseMetaDescription} student settings page`
    },
    "/student-help": {
        title: "Student Help",
        metaDescription: `${baseMetaDescription} student help page`
    },
    "/student-help/student-terms-and-privacy-policy": {
        title: "Student Terms And Privacy Policy",
        metaDescription: `${baseMetaDescription} student terms and privacy policy page`
    },
    "/student-settings/profile": {
        title: "Student Profile",
        metaDescription: `${baseMetaDescription} student profile page`
    },
    "/school-profile": {
        title: "School Profile",
        metaDescription: `${baseMetaDescription} school profile page`
    },
    "/student-verifyCode": {
        title: "Student Verify Code",
        metaDescription: `${baseMetaDescription} student verify code page`
    },
    "/facilitator-login": {
        title: "Facilitator Login",
        metaDescription: `${baseMetaDescription} facilitator login page`
    },
    "/facilitator-workshop": {
        title: "Facilitator Workshop",
        metaDescription: `${baseMetaDescription} facilitator workshop page`
    },
    "/participant-login": {
        title: "Participant Login",
        metaDescription: `${baseMetaDescription} participant login page`
    },
    "/participant-workshop": {
        title: "Participant Workshop",
        metaDescription: `${baseMetaDescription} participant workshop page`
    },
    "/virtual-school/virtual-student-forgot-password": {
        title: "Virtual Student Forgot Password",
        metaDescription: `${baseMetaDescription} virtual student forgot password page`
    },
    "/virtual-school/virtual-teacher-login": {
        title: "Virtual Teacher Login",
        metaDescription: `${baseMetaDescription} virtual teacher login page`
    },
    "/virtual-school/virtual-student-signup": {
        title: "Virtual Student Signup",
        metaDescription: `${baseMetaDescription} virtual student signup page`
    },
    "/virtual-school/virtual-student-login": {
        title: "Virtual Student Login",
        metaDescription: `${baseMetaDescription} virtual student login page`
    },
    "/virtual-school/student-classroom": {
        title: "Virtual Student Classroom",
        metaDescription: `${baseMetaDescription} virtual student classroom page`
    },
    "/virtual-school/teacher-classroom": {
        title: "Virtual Teacher Classroom",
        metaDescription: `${baseMetaDescription} virtual teacher classroom page`
    },
    "/virtual-school": {
        title: "Virtual Vacation School",
        metaDescription: `${baseMetaDescription} virtual vacation school landing page`
    },
    "/virtual-school/virtual-signup": {
        title: "Virtual Vacation School Registration",
        metaDescription: `${baseMetaDescription} virtual vacation school signup page`
    },
    "/virtual-school/virtual-login": {
        title: "Virtual Vacation School Login",
        metaDescription: `${baseMetaDescription} virtual vacation school login page`
    },
    "/virtual-school/payment-success": {
        title: "Payment Successful",
        metaDescription: `${baseMetaDescription} virtual vacation school payment success page`
    },
    "/virtual-school/payment-failure": {
        title: "Payment Failed",
        metaDescription: `${baseMetaDescription} virtual vacation school payment failure page`
    },
    "/virtual-school/payment-cancel": {
        title: "Payment Cancelled",
        metaDescription: `${baseMetaDescription} virtual vacation school payment cancel page`
    },
}